import React, { useState } from "react";
const GroupsTab = (props) => {
    
    const {firstTab, secondTab, thirdTab, webvrurl} = props;
    const [activeStatus, setActiveStatus] = useState(1);
    return (
        <div className="mt-20 h-fit relative">
            <div className="xl:w-full xl:mx-0  ">
                <ul className="flex">
                    <li onClick={() => setActiveStatus(1)} className="mr-10">
                        <label className={activeStatus == 1 ?
                            "text-yellow-600 font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap underline underline-offset-[18px] decoration-[5px] z-10 decoration-yellow-600 cursor-pointer"
                            :
                            " text-[#009269] font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap cursor-pointer"}>
                            ¿Qué?
                        </label>
                    </li>
                    <li onClick={() => setActiveStatus(2)} className="mr-10">
                        <label className={activeStatus == 2 ?
                            "text-yellow-600 font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap underline underline-offset-[18px] decoration-[5px] z-10 decoration-yellow-600 cursor-pointer"
                            :
                            " text-[#009269] font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap cursor-pointer"}>
                            ¿Por qué?
                        </label>
                    </li>
                    <li onClick={() => setActiveStatus(3)} className="">
                        <label className={activeStatus == 3 ?
                            "text-yellow-600 font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap underline underline-offset-[18px] decoration-[5px] z-10 decoration-yellow-600 cursor-pointer"
                            :
                            " text-[#009269] font-bold lg:text-3xl md:text-2xl sm:text-xl text-xl whitespace-nowrap cursor-pointer"}>
                            ¿Dónde y cuándo?
                        </label>
                    </li>

                </ul>
                <div className="py-4">
                    <div className="w-full border-t  border-[#009269] "></div>
                </div>
                <span className="lg:text-lg md:text-base sm:text-sm text-sm  text-white  lg:mr-36 mt-5 absolute">
                    {activeStatus == 1 && firstTab}
                    {activeStatus == 1 && webvrurl != undefined && <div className="mt-10 mb-10 bg-[#009269] font-bold w-fit p-4">
                    <a href={webvrurl} className="items-center inline-flex">
                        Actividad Interactiva
                    </a>
                    </div>}
                    </span>
                <span className="lg:text-lg md:text-base sm:text-sm text-sm  text-white lg:mr-36 mt-5 absolute">{activeStatus == 2 && secondTab}</span>
                <span className="lg:text-lg md:text-base sm:text-sm text-sm  text-white lg:mr-36 mt-5 absolute">{activeStatus == 3 && thirdTab}</span>
            </div>
        </div>
    );
};
export default GroupsTab;